import { cn } from 'src/lib/utils'
import { CustomTypographyProps } from '../Types'

function Ul({ children, className }: CustomTypographyProps) {
    return (
        <ul className={cn("my-6 ml-6 list-disc [&>li]:mt-2", className)}>{children}</ul>
    )
}

export default Ul